var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"no-margin-top":"","title":"Listagem"}},[_c('rkm-table',{ref:"RkmTable",attrs:{"fields":_vm.fields.tables.prontuariosUnidades,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }